export const contactCommonTypeFilter = 'contactCommonTypeFilter';
export const contactCommonConditionFilterName = 'contactCommonConditionFilterName';
export const contactCommonSearchFilterName = 'contactCommonSearchFilterName';
export const contactMultiTypeFilterName = 'contactMultiTypeFilterName';
export const contactIMFilterName = 'contactIMFilterName';
export const contactOrgIdEqTeamFilterName = 'contactOrgIdEqTeamFilterName';
export const contactOrgIdNeqTeamFilterName = 'contactOrgIdNeqTeamFilterName';
export const contactOrgIdNeqPersonOrgFilterName = 'contactOrgIdNeqPersonOrgFilterName';
export const contactExcludeSelfFilterName = 'contactExcludeSelfFilterName';
export const contactGrepRelateEnterpriseFilterName = 'contactGrepRelateEnterpriseFilterName';
export const contactGrepInvalidEnterpriseFilterName = 'contactGrepInvalidEnterpriseFilterName';
export const customerFilterNames = {
    searchContact: 'searchContact',
    searchOrg: 'searchOrg',
    searchMyCustomer: 'searchMyCustomer',
    searchMemoryContact: 'searchMemoryContact',
};
export const contactCustomerSyncTime = 'contactCustomerSyncTime';
export const YUNXIN_NONE_SENTINEL = '__none__';
